import {Answer} from 'Models'


export const calcSimpleMaxPoints = answer => {
    const q = answer.question()
    return q.countPerAnswer()   ? q.realQuestionsCount() * Number(q.points())
                                : Number(q.points())
}

export const calcSimplePoints = answer =>
    answer.isCorrect() ? Number(answer.question().points()) : 0
